

const LocationDescription = ({ name, description,
    //  latitude, longitude, zoom_level, mapLoaded, toggleMap,map_style
     }) => {
        const scopeStyles = (html) => {
            return html.replace(/<style([^>]*)>([\s\S]*?)<\/style>/gi, (match, attr, css) => {
                // Prefix every selector inside the style tag with .full_description_text
                const scopedCss = css.replace(/(^|\})\s*([^{]+)/g, (fullMatch, brace, selector) => {
                    if (selector.includes('@')) return fullMatch; // Skip @media, @keyframes
                    return `${brace} .full_description_text ${selector}`;
                });
                return `<style${attr}>${scopedCss}</style>`;
            });
        };
    return (
        <section className="container welcome">
            {/* <div className="container"> */}
                <div className="content_box_dyn mb-5">
                    {
                        name !== '' &&
                        <div className="sectionTitle">
                            <h3>More to know about {name}</h3>
                        </div>
                    }
                    <div
                        className="full_description_text comon-tags-class"
                        dangerouslySetInnerHTML={{ __html: description ? scopeStyles(description) : "" }}
                    />
                    {/* <div className="mainContentBox ">
                        {
                            latitude &&
                            <>
                                <div className="sectionTitle">
                                    <h3>Place on Map </h3>
                                </div>
                                <div className="clickMap">
                                    <button className="btn btnMap" type='button' onClick={toggleMap}>Show Me In The Map</button>
                                    <div className="mapBox mt-3" style={{
                                        opacity: 0,
                                        maxHeight: "0",
                                        overflow: "hidden",
                                        transition: "opacity 0.5s ease, max-height 0.5s ease",
                                    }}>
                                        {
                                            // mapLoaded &&
                                            <MapboxNew
                                                lat={Number(latitude)}
                                                lng={Number(longitude)}
                                                zoom={zoom_level}
                                                mapLoaded={mapLoaded}
                                                mapType={map_style}
                                            />
                                        }
                                    </div>
                                </div>
                            </>
                        }
                    </div> */}
                </div>
            {/* </div> */}
        </section>
    )

}
export default LocationDescription